import React from 'react';

const PageTitleServicesInside = () => {
    return (
        <div id="page-title">
            <div className="wrapper text-center">
                <h1 className="large">Hair Treatments</h1>
            </div>
        </div>
    );
};

export default PageTitleServicesInside;
